import { Injectable, Injector } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router, RoutesRecognized } from '@angular/router';
import { ApplicationInited, AuthService, ElementsService, ProjectService, StoreService } from 'dbweb-core';
import { IconList } from './icon-list';
@Injectable({
	providedIn: 'root'
})
export class AppLoadService {
	private auth: AuthService;
	private store: StoreService;
	private router: Router;
	constructor(
		private injector: Injector,
		private eles: ElementsService,
		private project: ProjectService,
		private title: Title,
		iconRegistry: MatIconRegistry,
		sanitizer: DomSanitizer,
		private iconList: IconList // private snackBar: MatSnackBar
	) {
		// this.goRoute = this.goRoute.bind(this);
		Object.keys(this.iconList.icons).forEach(ns => {
			this.iconList.icons[ns].forEach(cate => {
				cate.icons.forEach(icon => {
					iconRegistry.addSvgIconInNamespace(
						ns,
						icon.name,
						sanitizer.bypassSecurityTrustResourceUrl('assets/icon/' + icon.fs)
					);
				});
			});
		});
	}
	initializeApp(): Promise<any> {
		const This = this;
		window.onbeforeunload = () => {
			if (This.store) {
				This.store.save();
			}
		};
		this.project.applicationStatus = 'start-init';
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				// è·åProjectåç¼
				let projectName: string;
				let creator: string;
				This.router = this.injector.get(Router);
				const subscribeRouter = This.router.events.subscribe(event => {
					if (event instanceof RoutesRecognized) {
						subscribeRouter.unsubscribe();
						// é²æ­¢æ ¹ç®å½è·³è½¬å°loginï¼urlåå°çæ¯æ ¹ç®å½
						const paths = event.urlAfterRedirects.split('/');
						creator = decodeURIComponent(decodeURI(paths[2]));
						projectName = decodeURIComponent(decodeURI(paths[3]));
						const eleName = decodeURIComponent(decodeURI(paths[4]));
						this.project.setProject(projectName, creator);
						// è¿éä¸è½èªå¨æ³¨å¥authserviceï¼å ä¸ºå¶ç¨å°äºrouterï¼ä¼åºç°undefine
						This.auth = this.injector.get(AuthService);
						This.auth.serverIsLogged().subscribe(
							v => {
								This.project.getProjectInfo().subscribe(state => {
									this.title.setTitle(this.project.projectLabel);
									this.eles.setPub(this.project.publicElements);
									if (v) {
										this.store = this.injector.get(StoreService);
										this.store.load();
									} else {
										// å¤æ­æ¯å¦æ¯å¬å±çèåé¡¹ï¼å¬å±çèåé¡¹ä¸éè¦éæ°è·¯ç±
										if (!this.eles.getPubEles()[eleName]) {
											// å¦ææ²¡æç»å½ï¼åè·¯ç±å°é»è®¤é¡µ
											this.router.navigate(['']);
										}
									}
									resolve();
									return;
								});
							},
							err => {
								// this.snackBar.open(err.message, 'ç¡®å®', { verticalPosition: 'top' });
								reject();
							}
						);
					}
				});
			});
		}).then(
			v => {
				this.project.applicationStatus = 'init-done';
				ApplicationInited.next(v);
			},
			v => {
				this.project.applicationStatus = 'init-error';
				// è·¯ç±å°é»è®¤é¡µé¢ï¼è¦é²æ­¢å½åurlæ¯å·ä½åé¨çä¸å¡åè½ï¼æ²¡æéå¯¹init-errorçå¤çåç°
				// é»è®¤é¡µé¢ä¸è¬æ¯loginé¡µé¢ï¼æå¯¹è¿ç§æåµçåç°å¤ç
				this.router.navigate(['']);
			}
		);
	}
}
